import { FC, ReactElement } from 'react'

import { ConnectedRegistration } from '@/connectors'

export const RegistrationPage: FC = (): ReactElement => (
    <ConnectedRegistration />
)
